module.exports = __webpack_public_path__ + "static/virsical-LOGO.cd5893c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/virsical-LOGO.png
// module id = 4zGm
// module chunks = 0